export const EXPLORE_GLOBE_ICON_URL =
    'https://rukmini-ct.flixcart.com/f_auto,q_auto,w_16,h_16/staticresource-prod/images/explore/Triipy.svg'

export const EXPLORE_CTA_LABELS = {
    SEARCH_FLIGHTS: 'Search Flights',
    EXPLORE: 'Explore',
} as const

export const EXPLORE_CT_EXPERIMENT = {
    NAME: 'explore_ct_desktop',
    COOKIE: 'explore_ct',
    PARAM: 'variant',
    VARIANTS: {
        CONTROL: 'control',
        TEST: 'test',
    },
} as const

/** Internal allow-list — signed-in users with these emails see Explore (keep in sync with flights-pwa). */
export const EXPLORE_ALLOWED_EMAILS = [
    'manjari.singhal@cleartrip.com',
    'manoj.awasthi@cleartrip.com',
    'sujit.jare@cleartrip.com',
    'raj.smasih@cleartrip.com',
    'arnav.sharma@cleartrip.com',
    'mayank.kumargaur@cleartrip.com',
    'amit.rana5@cleartrip.com',
    'sonia.ravi@cleartrip.com',
    'anant.shibe@cleartrip.com',
    'abhinav.shroff@cleartrip.com',
] as const
